import type { SigTagSize } from './SigTag'
import SigTag from './SigTag'

export default SigTag
export type { SigTagSize }
